import { graphql, useStaticQuery } from "gatsby"
import parse from "html-react-parser"
import React from "react"

function Wrapper({ children, contactLink }) {
  if (contactLink)
    return (
      <a
        href={contactLink}
        className="block bg-white hover:bg-greenGrey-100/20 rounded-lg shadow-xs shadow-sm"
      >
        {children}
      </a>
    )
  return (
    <div className="block bg-white rounded-lg shadow-xs shadow-sm">
      {children}
    </div>
  )
}
export default function JobOffersList({ locale }) {
  const { jobOffers_fr, jobOffers_en } = useStaticQuery(graphql`
    query JobOffersListQueryFr {
      jobOffers_fr: allWpJobOffer(
        filter: { language: { locale: { eq: "fr_FR" } } }
        sort: { attributes: { validitydate: ASC } }
      ) {
        nodes {
          ...JobOfferFragment
        }
      }
      jobOffers_en: allWpJobOffer(
        filter: { language: { locale: { eq: "en_GB" } } }
        sort: { attributes: { validitydate: ASC } }
      ) {
        nodes {
          ...JobOfferFragment
        }
      }
    }
  `)
  const jobOffers = locale === "fr_FR" ? jobOffers_fr.nodes : jobOffers_en.nodes

  return (
    <ul className="mt-10 space-y-4 lg:max-w-5xl mx-auto ">
      {jobOffers.map(jobOffer => (
        <li
          key={
            jobOffer.title +
            jobOffer.attributes.location +
            jobOffer.attributes.salary +
            jobOffer.attributes.workTime +
            jobOffer.attributes.validitydate
          }
        >
          <Wrapper contactLink={jobOffer.attributes.contactLink}>
            <div className="px-4 py-4 sm:px-6">
              <div className="flex items-center justify-between">
                <p className="truncate text-md font-bold text-blue-600 leading-5">
                  {jobOffer.title}
                </p>
                <div className="ml-2 flex flex-shrink-0">
                  <div className="rounded-full bg-scooter-100 px-3 py-1  flex items-center">
                    <dt className="sr-only">Lieu</dt>
                    <dl className="flex items-center space-x-2 text-sm ">
                      <i
                        className={`bx ${
                          jobOffer.attributes.location === "Remote"
                            ? "bxs-user-pin"
                            : "bxs-buildings"
                        } text-scooter-500 text-lg`}
                      />
                      <span className="text-scooter-500">
                        {jobOffer.attributes.location}
                      </span>
                    </dl>
                  </div>
                </div>
              </div>
              {jobOffer.excerpt && (
                <div className="text-charlestonGreen-500 text-sm pr-16">
                  {parse(jobOffer.excerpt)}
                </div>
              )}
              <div className="mt-2 sm:flex sm:justify-between">
                <div className="sm:flex ">
                  <div>
                    <dt className="sr-only">Type d’emploi</dt>
                    <dl className="flex items-start space-x-2 text-sm leading-5 mr-4">
                      <i className="bx bxs-briefcase text-charlestonGreen-500 text-lg" />
                      <span className="text-charlestonGreen-500">
                        {jobOffer.attributes.workTime}
                      </span>
                    </dl>
                  </div>
                  <div>
                    <dt className="sr-only">Salaire</dt>
                    <dl className="flex items-start space-x-2 text-sm leading-5">
                      <i className="bx bxs-dollar-circle text-charlestonGreen-500 text-lg" />
                      <span className="text-charlestonGreen-500">
                        {jobOffer.attributes.salary}
                      </span>
                    </dl>
                  </div>
                </div>
                <div className="mt-2 flex items-center text-sm text-gray-400 sm:mt-0">
                  <div>
                    <dt className="sr-only">Validité</dt>
                    <dl className="flex items-start space-x-2 text-sm leading-5">
                      <i className="bx bxs-calendar text-charlestonGreen-500 text-lg" />
                      <span className="text-charlestonGreen-500">
                        <span aria-hidden="true">Valable jusqu’au </span>
                        <time dateTime="2020-05-27T21:00:00.0">
                          {jobOffer.attributes.validitydate}
                        </time>
                      </span>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
          </Wrapper>
        </li>
      ))}
    </ul>
  )
}
